import {
  ChannelkartNetworkDelete,
  ChannelkartNetworkGet,
  ChannelkartNetworkPost,
  ChannelkartNetworkPut,
} from "./networkService";
import { EnvironmentRegistry } from "./registry/environmentRegistry";

export async function getLoadoutList(
  startDate: string,
  endDate: string,
  isLoaded: boolean,
  page: number,
  size: number = 1000
) {
  const loginid = JSON.parse(localStorage.authContext).user.loginId;

  const formattedStartDate = startDate.replace(" ", "T");
  const formattedEndDate = endDate.replace(" ", "T");
  const response = await ChannelkartNetworkGet(
    `${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadout?isLoaded=${isLoaded}&filter_creationTime_gt=${formattedStartDate}&filter_creationTime_lt=${formattedEndDate}&filter_supplier_eq=${loginid}&size=${size}&page=${page}`
  );
  return response;
}

export async function createLoadoutOrchestrator(requestBody: any) {
  const response = await ChannelkartNetworkPost(
    `/v1/loadoutOrchestrator`,
    requestBody
  );
  return response;
}

export async function createLoadout(requestBody: any) {
  const response = await ChannelkartNetworkPost(
    `${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadout`,
    requestBody
  );
  return response;
}

export async function updateLoadout(requestBody: any) {
  const response = await ChannelkartNetworkPut(
    `${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadout`,
    requestBody
  );
  return response;
}

export async function deleteLoadout(loadoutNumber: any) {
  const response = await ChannelkartNetworkDelete(
    `${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadout/${loadoutNumber}`
  );
  return response;
}

export async function getSingleLoadout(loadNumber: string, isLoaded: boolean) {
  const response = await ChannelkartNetworkGet(
    `${EnvironmentRegistry.getloadoutBaseUrl()}/v1/loadout?filter_loadNumber_eq=${loadNumber}&isLoaded=${isLoaded}`
  );
  return response;
}

export async function getVehicleMaster(vehicleId: string) {
  const loginid = JSON.parse(localStorage.authContext).user.loginId;
  const filter = vehicleId
    ? `vehicleId:${vehicleId}`
    : `supplier:${loginid} and status:Available`;
  const response = await ChannelkartNetworkGet(`/vehicleInfo?filter=${filter}`);
  return response;
}

export async function getActiveUsersBySupplierAndDesignation(
  supplier: string,
  designation: string
) {
  const response = await ChannelkartNetworkGet(
    `/users/${supplier}/${designation}?active=true`
  );
  return response;
}

export async function getRouteInfoList(supplier: string) {
  const response = await ChannelkartNetworkGet(
    `/v1/route?filter=supplier%3A${supplier}`
  );
  return response;
}

export async function getSalesDataByDeliveryDate(
  includeSalesDetails: boolean,
  startDate: string,
  endDate: string,
  creationTimeWise: boolean,
  page: number
) {
  const response = await ChannelkartNetworkGet(
    `/delivery/sales?size=1000&page=${page}&includeSalesDetails=${includeSalesDetails}&filter=${
      creationTimeWise
        ? `creationTime[gte]:${startDate} and creationTime[lte]:${endDate}`
        : `deliveryDate[gte]:${startDate} and deliveryDate[lte]:${endDate}`
    } &transformerOut=DeliveryInfoAddAdditionalData`
  );
  return response;
}

export async function getSalesDataListByDeliveryDate(
  includeSalesDetails: boolean,
  startDate: string,
  endDate: string,
  creationTimeWise: boolean,
  page: number,
  filters?: {
    [key: string]: { op: string; value: string | string[] }; // If you don't want to specify an operator, send an empty string "" in op
  },
  size: number = 1000
) {
  const filterParts = creationTimeWise
    ? [`creationTime[gte]:${startDate}`, `creationTime[lte]:${endDate}`]
    : [`deliveryDate[gte]:${startDate}`, `deliveryDate[lte]:${endDate}`];

  if (filters) {
    for (const [key, { op, value }] of Object.entries(filters)) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          filterParts.push(`${key}[${op}]:[${value.join(",")}]`);
        }
      } else if (value) {
        if (op) {
          filterParts.push(`${key}[${op}]:${value}`);
        } else {
          filterParts.push(`${key}:${value}`);
        }
      }
    }
  }

  const filterQuery = filterParts.join(" and ");
  const url = `/v3/sales/dmsInvoice?size=${size}&page=${page}&includeSalesDetails=${includeSalesDetails}&filter=${encodeURIComponent(
    filterQuery
  )}&transformerOut=DMSInvoiceAPITransformer`;

  const response = await ChannelkartNetworkGet(url);
  return response;
}

export async function getOrderListByDeliveryDate(
  startDate: string,
  endDate: string,
  type: string,
  page: number,
  filters?: {
    [key: string]: { op: string; value: string | string[] }; // If you don't want to specify an operator, send an empty string "" in op
  },
  size: number = 1000
) {
  const filterParts = [
    `deliveryDate[gte]:${startDate}`,
    `deliveryDate[lte]:${endDate}`,
    `type:${type}`,
  ];

  if (filters) {
    for (const [key, { op, value }] of Object.entries(filters)) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          filterParts.push(`${key}[${op}]:[${value.join(",")}]`);
        }
      } else if (value) {
        if (op) {
          filterParts.push(`${key}[${op}]:${value}`);
        } else {
          filterParts.push(`${key}:${value}`);
        }
      }
    }
  }

  const filterQuery = filterParts.join(" and ");
  const url = `/v2/orders?size=${size}&page=${page}&sort=deliveryDate:desc&filter=${encodeURIComponent(
    filterQuery
  )}&transformerOut=orderDetailSplitGet`;

  const response = await ChannelkartNetworkGet(url);
  return response;
}

export const getLoadoutExcelSheet = async (
  loadNumber: string,
  configName: string,
  fileName: string
) => {
  const lob = localStorage.getItem("lob") || "";

  const response = await ChannelkartNetworkPost(
    `${EnvironmentRegistry.getDatastreamUrl()}/download?attachment=true`,
    {
      configName: configName,
      params: {
        loadoutNumbers: loadNumber,
      },
    },
    { "X-Tenant-ID": lob },
    true
  );

  const downloadUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);

  return response;
};
